module.exports = __webpack_public_path__ + "static/media/feather.6a750f01.ttf";